import { routeHead } from "@/lib/routeHead";
import { META_DESCRIPTIONS } from "@/lib/metaDescriptions";
import { createFileRoute } from "@tanstack/react-router";
import InterimManagement from "@/pages/InterimManagement";

export const Route = createFileRoute("/pl/interim-management")({
  head: () => routeHead('Interim Management — AGAPE Polska', META_DESCRIPTIONS.interim.pl, '/pl/interim-management'),
  component: InterimManagement,
});
